// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pBO6","buttons":"styles_buttons__3qtz4"};